'use client';
import { useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import { EmbedCodeType } from './type';

type Props = {
  data: EmbedCodeType;
};

const EmbedCodeView = ({ data }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container || !data.html) return;

    container.innerHTML = '';

    const template = document.createElement('template');
    template.innerHTML = data.html;
    const nodes = Array.from(template.content.childNodes);

    nodes.forEach((node) => {
      if ((node as Element).tagName === 'SCRIPT') {
        const original = node as HTMLScriptElement;
        const script = document.createElement('script');
        Array.from(original.attributes).forEach((attr) =>
          script.setAttribute(attr.name, attr.value),
        );
        script.textContent = original.textContent;
        container.appendChild(script);
      } else {
        container.appendChild(node.cloneNode(true));
      }
    });
  }, [data.html]);

  if (!data.html) return null;

  return (
    <Box
      ref={containerRef}
      sx={{
        width: '100%',
        ...data.styling.sx,
      }}
    />
  );
};

export default EmbedCodeView;
